module.exports = __webpack_public_path__ + "static/img/banner-en.235721bf.png";